"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.gridTypes = exports.limitedSize = exports.defaultSize = exports.autoSize = exports.size = exports.kind = exports.color = exports.align = void 0;
var align = {
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left",
  CENTER: "center"
};
exports.align = align;
var color = {
  BLACK: "black",
  BLUE: "blue",
  GREEN: "green",
  GREY: "grey",
  ORANGE: "orange",
  LIGHT_BLUE: "lightBlue",
  LIGHT_ORANGE: "lightOrange",
  RED: "red"
};
exports.color = color;
var kind = {
  DEFAULT: "default",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  DESTRUCTIVE: "destructive",
  FLAT: "flat",
  MINOR: "minor",
  LINK: "link"
};
exports.kind = kind;
var size = {
  AUTO: "auto",
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge"
};
exports.size = size;
var autoSize = {
  AUTO: "auto",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
exports.autoSize = autoSize;
var defaultSize = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
exports.defaultSize = defaultSize;
var limitedSize = {
  SMALL: "small",
  MEDIUM: "medium"
};
exports.limitedSize = limitedSize;
var gridTypes = {
  GRID: "grid",
  NONE: "none",
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
};
exports.gridTypes = gridTypes;
//# sourceMappingURL=Constants.js.map